// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-thumbnail {
  --border-radius: 50%;
  --size: 100px;
}

.menu-content-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  background-color: #efefef;
  padding: 10px 20px;
  justify-content: space-evenly;
}
.menu-content-wrapper .menu-title {
  display: flex;
  width: 100%;
  gap: 15px;
  align-items: center;
  justify-content: center;
  border-bottom: 3px solid #ed143d;
  padding-bottom: 5px;
}
.menu-content-wrapper .menu-title h3 {
  font-weight: bold;
  margin: 10px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 3px;
}
.menu-content-wrapper .menu-hero {
  border-radius: 14px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.menu-content-wrapper .menu-hero ion-icon {
  font-size: 100px;
}
.menu-content-wrapper .menu-hero ion-text {
  text-align: center;
  font-size: 14px;
}
.menu-content-wrapper .menu-hero ion-text h4 {
  margin: 5px 0;
}
.menu-content-wrapper .menu-hero ion-text p {
  margin: 3px 0;
}
.menu-content-wrapper .menu-hero ion-text p ion-icon {
  margin-right: 5px;
  vertical-align: middle;
  font-size: 22px;
  color: #ed143d;
}
.menu-content-wrapper ion-menu-toggle {
  width: 100%;
}
.menu-content-wrapper ion-menu-toggle ion-item {
  --background: #f9f9f9;
  border-radius: 12px;
  margin: 10px 0;
}
.menu-content-wrapper ion-menu-toggle ion-item ion-label {
  font-size: 15px;
  font-weight: 600;
}
.menu-content-wrapper ion-menu-toggle ion-item ion-icon {
  font-size: 26px;
  color: #ed143d;
}
.menu-content-wrapper .menu-footer {
  border-bottom: 1px solid #ed143d;
  font-weight: 600;
}

ion-menu::part(container) {
  border-radius: 0 20px 20px 0;
  box-shadow: 4px 0px 16px rgba(0, 0, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAyCA;EACI,oBAAA;EACA,aAAA;AAxCJ;;AAgEA;EACI,aAAA;EAEA,mBAAA;EAEA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;AA/DJ;AAgEI;EACI,aAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,mBAAA;AA9DR;AAqEQ;EACI,iBAAA;EACA,cAAA;EACA,2CAAA;EACA,mBAAA;AAnEZ;AAuEI;EACI,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AArER;AAuEQ;EACI,gBAAA;AArEZ;AAwEQ;EACI,kBAAA;EACA,eAAA;AAtEZ;AAwEY;EACI,aAAA;AAtEhB;AAyEY;EACI,aAAA;AAvEhB;AAyEgB;EACI,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AAvEpB;AA6EI;EACI,WAAA;AA3ER;AA8EY;EAGI,qBAAA;EACA,mBAAA;EAEA,cAAA;AA/EhB;AAgFgB;EACI,eAAA;EACA,gBAAA;AA9EpB;AAiFgB;EACI,eAAA;EACA,cAAA;AA/EpB;AAuFI;EACI,gCAAA;EACA,gBAAA;AArFR;;AA0FA;EACI,4BAAA;EACA,2CAAA;AAvFJ","sourcesContent":["// .menu-header-content {\n//     background-color: var(--ion-color-danger);\n//     margin-top: constant(safe-area-inset-top);\n//     margin-top: env(safe-area-inset-top);\n// }\n\n// .menu-avatar {\n//     font-size: 100px;\n//     margin: 0 auto;\n// }\n\n// .menu-text {\n//     font-size: 14px;    \n// }\n\n// .menu-text:first-of-type {\n//     padding-top: 5px\n// }\n\n// .menu-nav-icon {\n//     font-size: 32px\n// }\n\n// .menu-nav-icon-1 {\n//     font-size: 29px;\n//     padding-left: 1px;\n// }\n\n// ion-content, ion-item{\n//     --background: var(--ion-color-primary);\n// }\n\n// ion-item {\n//     --min-height: 85px;\n//     --border-color: var(--ion-color-dark)\n// }\n\n// .menu-thumbnail-wrapper {\n//     width: 100px;\n// }\n\nion-thumbnail {\n    --border-radius: 50%;\n    --size: 100px;\n}\n\n// ion-header.menu-header {\n//     background-color: var(--ion-color-danger);\n// }\n\n// .spinner-background {\n//     position: absolute;\n//     top: 0;\n//     left: 0;\n//     bottom: 0;\n//     right: 0;\n//     background: rgba(0, 0, 0, 0.15);\n//     z-index: 999;\n//     display: flex;\n//     align-items: center;\n//     justify-content: center;\n// }\n\n// .filled {\n//     color: #E0061C;\n//   }\n\n.menu-content-wrapper {\n    display: flex;\n    // justify-content: space-between;\n    align-items: center;\n    // gap: 25px;\n    flex-direction: column;\n    height: 100%;\n    background-color: #efefef;\n    padding: 10px 20px;\n    justify-content: space-evenly;\n    .menu-title {\n        display: flex;\n        width: 100%;\n        gap: 15px;\n        align-items: center;\n        justify-content: center;\n        border-bottom: 3px solid #ed143d;\n        padding-bottom: 5px;\n\n        // img {\n        //     width: 42px;\n        //     border-radius: 14px;\n        // }\n\n        h3 {\n            font-weight: bold;\n            margin: 10px 0;\n            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);\n            letter-spacing: 3px;\n        }\n    }\n\n    .menu-hero {\n        border-radius: 14px;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        // background-color: #f9f9f9;\n        ion-icon {\n            font-size: 100px;\n        }\n\n        ion-text {\n            text-align: center;\n            font-size: 14px;\n\n            h4 {\n                margin: 5px 0;\n            }\n\n            p {\n                margin: 3px 0;\n\n                ion-icon {\n                    margin-right: 5px;\n                    vertical-align: middle;\n                    font-size: 22px;\n                    color: #ed143d;\n                }\n            }\n        }\n    }\n\n    ion-menu-toggle {\n        width: 100%;\n        // ion-list {\n            // --background:#efefef !important;\n            ion-item {\n                // --padding-top: 3px;\n                // --padding-bottom: 3px;\n                --background: #f9f9f9;\n                border-radius:12px;\n\n                margin:10px 0;\n                ion-label {\n                    font-size: 15px;\n                    font-weight: 600;\n                }\n\n                ion-icon {\n                    font-size: 26px;\n                    color: #ed143d;\n                }\n            }\n\n           \n        // }\n    }\n\n    .menu-footer {\n        border-bottom: 1px solid #ed143d;\n        font-weight: 600;\n        // margin-top: auto;\n    }\n}\n\nion-menu::part(container) {\n    border-radius: 0 20px 20px 0;\n    box-shadow: 4px 0px 16px rgba(0, 0, 0, 0.3);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
